import { DtoApiPager } from "./abst/DtoApiPager";
import { DtoBanksGetRes } from "./abst/DtoBanksGetRes";

export class DtoBanksGetResImple extends DtoBanksGetRes {
  public pager = new DtoApiPager();
}
